export default "__VITE_ASSET__CfX0eHN0__"